import React from "react";
import Spinner from "react-bootstrap/Spinner";

const index = () => {
  return <Spinner animation="grow" />;
};

export default index;
